import React, { useState, useEffect, useRef } from "react";
import { Flex, Text, Box, Icon } from "@chakra-ui/react";
import { FiArrowRight } from "react-icons/fi";

function CountBubble({ count }) {
  const [pulsing, setPulsing] = useState(false);
  const prevCount = useRef(count);

  useEffect(() => {
    if (prevCount.current !== count) {
      setPulsing(true);
      const t = setTimeout(() => setPulsing(false), 250);
      prevCount.current = count;
      return () => clearTimeout(t);
    }
    return undefined;
  }, [count]);

  return (
    <Box
      minWidth="24px"
      height="24px"
      px="6px"
      lineHeight="24px"
      borderRadius="12px"
      bg="white"
      color="black"
      fontSize="12px"
      fontWeight="bold"
      textAlign="center"
      transition="transform 0.25s ease-out"
      transform={pulsing ? "scale(1.3)" : "scale(1)"}
    >
      {count > 99 ? "99+" : count}
    </Box>
  );
}

const JobApplicationSteps = ({
  steps,
  activeStep,
  onTabChange,
}) => {
  return (
    <Flex direction="column" borderRadius="12px" gap="8px" bg="black" p="10px">
      <Flex align="center" gap="16px" role="tablist">
        {steps.map((step, index) => {
          const isActive = activeStep === step.label;
          const isDimmed = step.dimmed;
          const isLast = index === steps.length - 1;
          const nextIsDimmed = !isLast && steps[index + 1]?.dimmed;
          return (
            <React.Fragment key={step.label}>
              <Box
                cursor="pointer"
                onClick={() => onTabChange && onTabChange(step.label)}
                textAlign="center"
                p="4px 6px"
                borderRadius="8px"
                bg={isActive ? "whiteAlpha.300" : "transparent"}
                opacity={isDimmed && !isActive ? 0.6 : 1}
                role="tab"
                aria-selected={isActive}
              >
                <Flex align="center" gap="12px">
                  <Text
                    fontWeight={isActive ? "bold" : "normal"}
                    color={isActive ? "white" : "whiteAlpha.800"}
                    fontSize={isDimmed ? "sm" : "md"}
                  >
                    {step.label}
                  </Text>
                  <CountBubble count={step.count} />
                </Flex>
              </Box>
              {!isLast && (
                nextIsDimmed ? (
                  <Box w="1px" h="20px" bg="whiteAlpha.300" />
                ) : (
                  <Icon as={FiArrowRight} color="whiteAlpha.800" />
                )
              )}
            </React.Fragment>
          );
        })}
      </Flex>
      <Text fontSize="sm" color="whiteAlpha.800">
        Top matches for this role based on skills and experience.
        Reach out and invite the best-fit candidates to apply today.
      </Text>
    </Flex>
  );
};

export default JobApplicationSteps;